module.exports = __webpack_public_path__ + "static/fonts/PingFang-SC-Semibold.e9ad33e.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/PingFang-SC-Semibold.otf
// module id = Lzhz
// module chunks = 1